import React from 'react';
import { PaperClipOutlined } from '@ant-design/icons';
import {
  formatAttachmentSize,
  isImageAttachment,
  resolveAttachmentDownloadHref,
  type ChatPanelAttachmentRecord,
} from './chatPanelAttachments';
import styles from './ChatPanel.module.css';

export interface ChatPanelMessageAttachmentsProps {
  attachments: ChatPanelAttachmentRecord[];
}

export const ChatPanelMessageAttachments: React.FC<ChatPanelMessageAttachmentsProps> = ({
  attachments,
}) => {
  if (attachments.length === 0) return null;

  return (
    <ul className={styles.messageAttachmentList}>
      {attachments.map((item) => {
        const href = resolveAttachmentDownloadHref(item);
        const imagePreview =
          href && isImageAttachment(item.mimeType) ? href : item.dataUrl;

        return (
          <li key={item.id} className={styles.messageAttachmentItem}>
            {imagePreview && isImageAttachment(item.mimeType) ? (
              <a href={href ?? imagePreview} download={item.name} className={styles.messageAttachmentLink}>
                <img src={imagePreview} alt={item.name} className={styles.messageAttachmentImage} />
              </a>
            ) : href ? (
              <a
                href={href}
                download={item.name}
                className={styles.messageAttachmentLink}
                title={item.name}
                target="_blank"
                rel="noreferrer"
              >
                <PaperClipOutlined aria-hidden />
                <span>{item.name}</span>
                <span className={styles.attachmentSize}>{formatAttachmentSize(item.size)}</span>
              </a>
            ) : (
              <span className={styles.messageAttachmentLink}>
                <PaperClipOutlined aria-hidden />
                <span>{item.name}</span>
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};
